export default {
  site_name: '健康娱乐指南',
  site_full_name: '茄子视频污内容风险警示与健康娱乐替代指南',
  nav_home: '首页',
  nav_risk: '风险警示',
  nav_healthy: '健康替代',
  nav_legal: '法律合规',
  nav_youth: '青少年保护',
  nav_about: '关于我们',
  read_more: '了解更多',
  view_all: '查看全部',
  articles_count: '篇文章',
  contact_us: '联系我们',
  send_message: '发送留言',
  all_rights_reserved: '版权所有',
};